import { type CaseExpandEnum, type Case } from '@/common/types/case'
import { type CustomerExpandEnum, type Customer } from '@/common/types/customer'
import { type Interaction, type InteractionExpandEnum } from '@/common/types/interaction'

export enum EntityEnum {
  TICKET = 'TICKET',
  CUSTOMER = 'CUSTOMER',
  INTERACTION = 'INTERACTION',
}

export const NULLUUID: UUID = '00000000-0000-0000-0000-000000000000'

export enum ResourceEnum {
  TICKET = 'tickets',
  CUSTOMER = 'customers',
  INTERACTION = 'interactions',
}

export type MainEntity = Case | Customer | Interaction

export type MainEntityExpandKeys = keyof typeof InteractionExpandEnum | keyof typeof CaseExpandEnum | keyof typeof CustomerExpandEnum

export const MainEntityFieldInjectionMethods = {
  INCLUDE: 'INCLUDE',
  EXPAND: 'EXPAND',
} as const

export type FetchCallbackFunctions = {
  onSuccess?: () => void
  onFailure?: () => void
}
